// extracted by mini-css-extract-plugin
export default {"panel":"HttpBackend_panel__V1k1f"};